export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '1e0a0426-7291-465e-a220-403039050e8e';
export const MODAL_CLOSE_SEC = 2;
